import { categoryService } from '../../services/categoryService'
import * as actionTypes from './ActionTypes'

export const getCategoriesSuccess = categories => {
  return {
    type: actionTypes.GET_CATEGORIES_SUCCESS,
    payload: {
      categories,
    },
  }
}

export const getCategories = () => async dispatch => {
  const response = await categoryService.getCategories()
  if (response.isOk && response.data) {
    dispatch(getCategoriesSuccess(response.data))
  }
}
